import PropTypes from 'prop-types';

import CodeInline from './CodeInline';

const CodeBlock = ({ code, language }) => {
  return (
    <pre>
      <CodeInline code={code} language={language} />
    </pre>
  );
};

CodeBlock.defaultProps = {
  language: 'js',
};

// language types: if more are added, you must also adjust the babel config
// https://prismjs.com/#supported-languages
CodeBlock.propTypes = {
  code: PropTypes.string.isRequired,
  language: PropTypes.oneOf(['bash', 'css', 'html', 'js']),
};

export default CodeBlock;
